const Home = () => import('../views/Home.vue');
const Login = () => import('../views/Login.vue');

export default [
  {
    path: '/home', name: 'home', component: Home
  },
  {
    path: '/login', name: 'login', component: Login
  },
  {
    path: '*',
    name: 'default',
    redirect: '/home/*'
  }
];
